export const SR_API_ERROR = "sr_api_failed";
export const SR_PURCHASE_INDENTS_LIST = "rfq_SR_purchase_indents_list";
export const SR_PURCHASE_INDENTS_LIST_SUCCESS =
  "rfq_SR_purchase_indents_list_success";
export const SR_PURCHASE_INDENTS_LIST_CHECKED =
  "rfq_SR_purchase_indents_list_checked";
export const ALL_SR_PURCHASE_INDENTS_LIST_CHECKED =
  "all_rfq_SR_purchase_indents_list_checked";
export const SR_RFQ_SELECTED_SR_ITEM = "SR_rfq_selected_item";
export const SR_RFQ_SELECTED_ALL_VENDORS = "SR_rfq_selected_all_vendors";
export const SR_RFQ_SELECTED_VENDORS = "SR_rfq_selected_vendors";
export const SR_CELAR_VENDORS = "SR_celar_vendors";
export const SR_VENDORS_LIST = "rfq__SR_vendors_list";
export const SR_VENDORS_LIST_SUCCESS = "rfq_SR_vendors_list_success";
export const GET_SR_VENDORS_DATA = "get_SR_vendors_data";
export const SR_VENDORS_DATA_SUCCESS = "SR_vendors_data_success";
export const SR_REQUESTFORQUOTATION_ADD = "SR_requestforquotation_add";
export const SR_DOWNLOAD_RFQ_BUTTON = "RFQ_SR_download_rfq_button";

export const SR_RFQ_LIST = "sr_reqestforquotation_list";
export const SR_RFQ_LIST_SUCCESS = "sr_reqestforquotation_list_success";
export const SR_RFQ_LIST_COUNT = "sr_reqestforquotation_list_count";
export const SR_RFQ_LIST_COUNT_SUCCESS = "sr_reqestforquotation_list_count_success";

export const TOGGLE_SR_ITEM_MENU = "rfq_toggle_item_menu";

export const INPUT_SR_CHANGEVALUE = "rfq_input_SR_ChangeValue";
export const SELECT_SR_CHANGEVALUE = "rfq_Select_SR_ChangeValue";

export const SET_PARAMS = "rfq_set_params";
export const FILTER_INPUT_SR_CHANGEVALUE = "rfq_Filter_input_SR_ChangeValue";
export const FILTER_SELECT_SR_CHANGEVALUE = "rfq_Filter_Select_SR_ChangeValue";

export const RFQ_SR_ROW_DATA = "req_SR_row_data";
export const RFQ_SR_ROW_DATA_SUCCESS = "rfq_SR_row_data_success";

export const RF_SR_MODEL_LIST_OPEN = "sr_rf_listItem_model_open";
export const RF_SR_MODEL_LIST_CLOSE = "RF_listItem_model_close";
export const SR_LIST_LAYOUT = "rfq_SR_list_layout";

export const GENERATE_RFQ_PDF = "rfq_generate_pdf";

export const FILTERS_SHOW_SR_RIGHT_SIDEBAR = "RFQ_filter_show_sr_right_sidebar";
export const FILTERS_HIDE_SR_RIGHT_SIDEBAR = "RFQ_filter_hide_sr_right_sidebar";
export const CLEAR_SR_FILTER = "RFQ_clear_sr_filter";

export const ADD_SR_VENDORS = "SR_rfq_add_vendors";
export const TOOLTI_OPEN = "rfq_tooltip_open";

export const SR_PI_DETAILS_MODEL_OPEN = "SR_RFQ_PI_details_model_open";
export const SR_PI_DETAILS_MODEL_CLOSE = "RFQ_pi_details_model_close";
export const PI_SR_ROW_DATA_SUCCESS = "RFQ_pi_SR_row_data";

export const SR_CODE_DETAILS = "RFQ_sr_code_details";
export const SR_CODE_DETAILS_SUCCESS = "RFQ_sr_code_details_Successful";
export const ADD_SR_VENDORS_MODEL_CLOSE = "SR_RFQ_add_vendors_model_close";
export const ADD_SR_VENDORS_MODEL_OPEN = "SR_RFQ_add_vendors_model_open";

export const MR_SR_ITEM_IMAGES = "RFQ_sr_item_images";
export const MR_SR_ITEM_IMAGES_SUCCESS = "RFQ_sr_item_images_Successful";
export const PI_MR_SR_ITEM_IMAGES_MODEL_CLOSE = "RFQ_sr_item_images_model_close";

export const RFQ_PI_SR_ITEM_CANCEL = "RFQ_PI_SR_ITEM_cancel";
